import { ChartColumn, Droplet, House, MessageCircle, Sprout, type LucideIcon } from "lucide-react";
import type { ClientTabPath } from "@ferrivia/analytics";
import type { Market } from "@ferrivia/api-contract";

export interface TabRoute {
  /** Typed against the analytics catalog's own tab enum rather than `string`,
      so a new tab cannot be added to the bar without `nav.tab_changed`
      learning about it — the two lists drifting would silently stop the new
      tab from being measured. */
  path: ClientTabPath;
  labelKey: string;
  icon: LucideIcon;
}

export const TABS: TabRoute[] = [
  { path: "/", labelKey: "nav.home", icon: House },
  { path: "/infusion", labelKey: "nav.infusion", icon: Droplet },
  { path: "/support", labelKey: "nav.support", icon: Sprout },
  { path: "/results", labelKey: "nav.results", icon: ChartColumn },
  { path: "/chat", labelKey: "nav.chat", icon: MessageCircle },
];

const US_TABS: TabRoute[] = TABS.filter((tab) => tab.path !== "/infusion");

export function tabsFor(market: Market): TabRoute[] {
  return market === "us" ? US_TABS : TABS;
}
